<template>
  <div class="flex flex-col space-y-2.5">
    <base-snackbar :errors.sync="expenseCategoryGetErrors"></base-snackbar>
    <base-snackbar :errors.sync="expensePostErrors"></base-snackbar>
    <div style="width: 100%" class="flex flex-col space-y-2.5">
      <v-autocomplete outlined="outlined" dense="dense" hide-details="auto" :items="expenseCategoryList"
        label="Expense Category" item-value="id" item-text="description" v-model="expenseCategory"
        :error-messages="expensePostErrors.expense_category_id" return-object="return-object"></v-autocomplete>
      <v-text-field outlined="outlined" dense="dense" hide-details="auto" label="description"
        :error-messages="expensePostErrors.description" v-model="description"></v-text-field>
      <v-text-field outlined="outlined" dense="dense" hide-details="auto" label="Cost" type="number"
        :error-messages="expensePostErrors.cost" v-model.number="cost"></v-text-field>
      <v-text-field outlined="outlined" dense="dense" hide-details="auto" label="Date" type="date"
        :error-messages="expensePostErrors.date" v-model="date"></v-text-field>
      <v-btn color="primary" dense="dense" dark="dark" :loading="expensePosting"
        @click="sendRequestExpense"><span>add</span></v-btn>
    </div>
  </div>
</template>
<script>
import VueRequestHandler from '@/classes/VueRequestHandler.class'
import requestVars from '@/extra-functions/request-vars.extra'
import expenseCategoryRepository from '@/repositories/expense-category.repository'
import expenseRepository from '@/repositories/expense.repository'
import { mapActions } from 'vuex'

const { currentDate } = Window

const [expenseCategoryGetVars, expenseCategoryGetVarNames] = requestVars({ identifier: 'expense-category' })
const [expensePostVars, expensePostVarNames] = requestVars({ identifier: 'expense', request: 'post', hasData: false })

const expenseCategoryGetHandler = new VueRequestHandler(null, expenseCategoryGetVarNames)
const expensePostHandler = new VueRequestHandler(null, expensePostVarNames)

const inputVars = () => ({
  id: null,
  expenseCategory: {},
  description: null,
  cost: null,
  date: currentDate(),
})
export default {
  name: 'CreateExpenses',
  created() {
    this.fetchExpenseCategories()
    this.initWebsocketEvents()
  },
  beforeDestroy() {
    this.websocketEvents.forEach(eventId => {
      this.$store.dispatch('websocket/detachFromListener', [eventId])
    })
    this.websocketEvents = []
  },
  data: () => ({
    ...inputVars(),
    ...expenseCategoryGetVars,
    ...expensePostVars,
    websocketEvents: [],
  }),
  computed: {
    storeId() {
      return this.$store.state.settings.storeId
    },
    expenseCategoryId() {
      return this.expenseCategory.id
    },
  },
  methods: {
    ...mapActions({
      addItemToExpenses: 'expense/addItemToList',
      removeItemFromExpenses: 'expense/removeItemFromList',
      clearExpenses: 'expense/clearListItems',
    }),
    fetchExpenseCategories() {
      const handler = expenseCategoryGetHandler
      const repository = expenseCategoryRepository.index
      handler.setVue(this)
      handler.execute(repository)
    },
    sendRequestExpense() {
      const handler = expensePostHandler
      const repository = expenseRepository.verify
      const { data } = this.getFieldInputs()
      handler.setVue(this)
      handler.execute(repository, [data], this.expenseVerifyStatusOk)
    },
    expenseVerifyStatusOk() {
      const { data } = this.getFieldInputs(['id'])
      this.addItemToExpenses(data)
      this.reset()
    },
    async initWebsocketEvents() {
      const dbStoreEventId = await this.$store.dispatch('websocket/attachToListener', ['DBStoreEvent', this.dbStoreEvent])
      const dbUpdateEventId = await this.$store.dispatch('websocket/attachToListener', ['DBUpdateEvent', this.dbUpdateEvent])
      this.websocketEvents.push(dbStoreEventId, dbUpdateEventId)
    },
    reset() {
      const defaults = inputVars()
      Object.keys(defaults).forEach(key => {
        this[key] = defaults[key]
      })
    },
    dbStoreEvent({ data, model }) {
      if (!model || this.$objectEmpty(data)) return
      if (model === 'ExpenseCategory') {
        this.expenseCategoryDBStoreEvent(data)
      }
    },
    dbUpdateEvent({ data, model }) {
      if (!model || this.$objectEmpty(data)) return
      if (model === 'ExpenseCategory') {
        this.expenseCategoryDBUpdateEvent(data)
      }
    },
    expenseCategoryDBUpdateEvent(data) {
      this.expenseCategoryList = this.expenseCategoryList.map(item => {
        if (Number(data.id) === Number(item.id)) {
          return Object.assign({ ...data })
        }
        return Object.assign({ ...item })
      })
    },
    expenseCategoryDBStoreEvent(data) {
      this.expenseCategoryList.push(data)
    },
    getFieldInputs(ex = null, inc = null) {
      const excluded = ex || ['id', 'expenseCategory']
      const included = inc || ['storeId', 'expenseCategoryId']
      const { id } = this
      const data = Object.keys(inputVars())
        .filter(key => !excluded.includes(key))
        .concat(included)
        .reduce((result, key) => {
          result[key.camelToSnakeCase()] = this[key]
          return result
        }, {})
      return { id, data }
    },
  },
}
</script>
